import React from 'react';
import PropTypes from 'prop-types';
import './_Carrousel.scss';

const Carrousel = (
  {
    images, changeImage, pos,
  },
) => (
  <div className='carrousel-product'>
    {images.map((img, i) => (
      <img
        key={img}
        src={img}
        alt=''
        className={`carrousel-product__img ${pos === i && 'carrousel-product__current'}`}
        onClick={() => changeImage(i)}
      />
    ))}
  </div>
);

Carrousel.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  images: PropTypes.array,
  changeImage: PropTypes.func,
  pos: PropTypes.number,
};

export default Carrousel;
